<li class="dropdown" >
    <a dropdown-toggle class="report_dropdown" data-toggle="dropdown" href="javascript:void(0)">Help</a>
    <ul class="dropdown-menu">
      <li><a target="_blank" [href]="interfaceManualPath">Using BankExec®</a></li>
      <li class="dropdown-submenu"><a href="javascript:void(0)" class="submenu">Getting Started</a>
        <ul class="dropdown-menu">
          <li> <a href="javascript:void(0)" (click)="callMePopupShow('side_popup1')">How the Simulation Works</a></li>
          <li> <a href="javascript:void(0)" (click)="callMePopupShow('side_popup2')">Your Bank and The Competitive Environment</a></li>
          <li> <a href="javascript:void(0)" (click)="callMePopupShow('side_popup3')">What Types of Decisions Can Be Made in BankExec®?</a></li>
          <li> <a href="javascript:void(0)" (click)="callMePopupShow('side_popup4')">Running Simulations</a></li>
          <li> <a href="javascript:void(0)" (click)="callMePopupShow('side_popup5')">Submit Current Decisions</a></li>
        </ul>
      </li>
      <li *ngIf="role!='student'"><a href="{{interfacePath}}" target="_blank">BankExec® Administration Manual</a></li>
      <li ><a href="{{decisionPath}}" target="_blank">Participant Decision Manual</a></li>
      <li> <a href="javascript:void(0)" (click)="callMePopupShow('side_popup6')">  Contact Us</a></li>
    </ul>
  <div class="side_popup">
    <div class="side_popup_ul">
      <li *ngIf="side1" id="side_popup1" [ngClass]="getSelectPop('side_popup1')">
          <div class="side_popup_title">
          <a href="javascript:void(0)" class="colose_side_popup"> <i class="fa fa-times cross " (click)="getSelectClose('side_popup1')" aria-hidden="true"></i></a>
          <h4> How the Simulation Works</h4>
        </div>
        <div class="side_popup_containt">
        <help-popup-simulation></help-popup-simulation>
        <a href="javascript:void(0)" (click)="callMePopupShow('side_popup2')"> Your Bank and the Competitive Environment</a>
      </div>
      </li>
      <li *ngIf="side1" id="side_popup2" [ngClass]="getSelectPop('side_popup2')">
        <div class="side_popup_title">
          <a href="javascript:void(0)" class="colose_side_popup" (click)="getSelectClose('side_popup1')"> <i class="fa fa-times cross " aria-hidden="true"></i></a>
          <h4>  Your Bank and the Competitive Environment</h4>
        </div>
        <div class="side_popup_containt">
          <help-popup-yourbank></help-popup-yourbank>
          <a href="javascript:void(0)" (click)="callMePopupShow('side_popup3')"> What Types of Decisions Can Be Made in BankExec®?</a>
        </div>
      </li>
      <li *ngIf="side1" id="side_popup3" [ngClass]="getSelectPop('side_popup3')">
        <div class="side_popup_title">
          <a href="javascript:void(0)" class="colose_side_popup" (click)="getSelectClose('side_popup1')"> <i class="fa fa-times cross " aria-hidden="true"></i></a>
          <h4>  What Types of Decisions Can Be Made in BankExec®?</h4>
        </div>
        <div class="side_popup_containt">
          <help-popup-decisiontype></help-popup-decisiontype>
          <a href="javascript:void(0)" (click)="callMePopupShow('side_popup4')"> Running Simulations</a>
        </div>
      </li>
      <li *ngIf="side1" id="side_popup4" [ngClass]="getSelectPop('side_popup4')">
        <div class="side_popup_title">
          <a href="javascript:void(0)" class="colose_side_popup" (click)="getSelectClose('side_popup1')"> <i class="fa fa-times cross " aria-hidden="true"></i></a>
          <h4> Running Simulations</h4>
        </div>
        <div class="side_popup_containt">
          <help-popup-runningsimulation></help-popup-runningsimulation>
          <a href="javascript:void(0)" (click)="callMePopupShow('side_popup5')"> Submit Current Decisions</a>
        </div>
      </li>
      <li *ngIf="side1" id="side_popup5" [ngClass]="getSelectPop('side_popup5')">
        <div class="side_popup_title">
          <a href="javascript:void(0)" class="colose_side_popup" (click)="getSelectClose('side_popup1')"> <i class="fa fa-times cross " aria-hidden="true"></i></a>
          <h4> Submit Current Decisions</h4>
        </div>
        <div class="side_popup_containt">
          <help-popup-currentdecisions></help-popup-currentdecisions>
        </div>
      </li>
      <li *ngIf="side1" id="side_popup6" [ngClass]="getSelectPop('side_popup6')">
        <div class="side_popup_title">
          <a href="javascript:void(0)" class="colose_side_popup" (click)="getSelectClose('side_popup1')"> <i class="fa fa-times cross " aria-hidden="true"></i></a>
          <h4>Contact Us</h4>
        </div>
        <div class="side_popup_containt">
          <help-popup-contact></help-popup-contact>
        </div>
      </li>
    </div>
  </div>
  